import React, { useState } from 'react';
import Colors from '../colors';
import { IconButton, InputAdornment, OutlinedInput } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

const StyledOutlinedInput = styled(OutlinedInput)(() => ({
    height: '50px',
    background: Colors.lightGray,
    borderRadius: '8px',
    border: 'none !important',
    width: '100%',
    fontFamily: 'Jost',
    fontWeight: 400,
    fontSize: '16px',
    paddingLeft: '10px',
    paddingRight: '5px',
    outline: 'none',
    boxShadow: 'none',
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'transparent',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        border: '2px solid ' + Colors.gray,
    },
    '&:focus-within .MuiOutlinedInput-notchedOutline': {
        border: `2px solid ${Colors.blue2}`
    },
}));

function PasswordInput({ label, setText, value = '', name }) {
    const [showPassword, setShowPassword] = useState(false)

    const inputContainerStyles = {
        marginBottom: '10px',
        width: '100%',
    }

    const labelStyles = {
        fontFamily: 'Jost',
        fontWeight: 600,
        color: 'var(--dark-gray)',
        textTransform: 'capitalize',
    }

    return (
        <div style={inputContainerStyles}>
            <label style={labelStyles}>{label}</label>
            <StyledOutlinedInput
                name={name}
                type={showPassword ? 'text' : 'password'}
                defaultValue={value}
                inputProps={{ style: { padding: 0, paddingLeft: '2px' } }}
                onChange={(e) => setText(e.target.value)}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowPassword(!showPassword)}
                            edge="end"
                            sx={{ marginRight: '5px' }}
                        >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                    </InputAdornment>
                }
            />
        </div>
    )
}

export default PasswordInput;